export const PageHeader = ({ title, sub, children }) => (
  <div className="flex flex-wrap items-end justify-between gap-4 mb-6">
    <div>
      <p className="text-xs font-mono2 uppercase tracking-[0.2em] text-emerald-600 font-semibold mb-1">GREENRGY · ACCOUNTS</p>
      <h1 className="text-2xl sm:text-3xl font-bold tracking-tight text-slate-900">{title}</h1>
      {sub && <p className="text-sm text-slate-600 mt-1">{sub}</p>}
    </div>
    {children && <div className="flex gap-2">{children}</div>}
  </div>
);

export const StatCard = ({ label, value, icon: Icon, tone = "emerald", testid }) => {
  const tones = {
    emerald: "border-emerald-500/30 text-emerald-600",
    amber: "border-amber-500/30 text-amber-600",
    red: "border-red-500/30 text-red-600",
    blue: "border-blue-500/30 text-blue-600",
  };
  return (
    <div data-testid={testid} className={`rounded-2xl p-5 bg-white border ${tones[tone]} shadow-[0_0_25px_rgba(16,185,129,0.06)] hover:shadow-[0_0_35px_rgba(16,185,129,0.16)] transition-shadow duration-300`}>
      <div className="flex items-center justify-between mb-3">
        <span className="text-xs font-mono2 uppercase tracking-[0.15em] text-slate-500">{label}</span>
        {Icon && <Icon className="w-4 h-4 opacity-70" />}
      </div>
      <div className="font-mono2 font-bold text-xl sm:text-2xl text-slate-900 tracking-tight">{value}</div>
    </div>
  );
};

export const EmptyState = ({ icon: Icon, title, sub }) => (
  <div className="flex flex-col items-center justify-center py-16 text-center">
    {Icon && <Icon className="w-10 h-10 text-slate-700 mb-3" />}
    <p className="text-slate-700 font-medium">{title}</p>
    {sub && <p className="text-sm text-slate-500 mt-1">{sub}</p>}
  </div>
);

export const RoleBadge = ({ role }) => {
  const map = {
    admin: "bg-emerald-500/15 text-emerald-600 border-emerald-500/40",
    accounts: "bg-blue-500/15 text-blue-600 border-blue-500/40",
    backoffice: "bg-amber-500/15 text-amber-600 border-amber-500/40",
  };
  return (
    <span data-testid={`role-badge-${role}`} className={`px-2.5 py-0.5 rounded-full border text-[11px] font-mono2 uppercase tracking-wider ${map[role] || map.backoffice}`}>
      {role}
    </span>
  );
};

export const SlabBadge = ({ slab }) => {
  const map = {
    retail: "bg-slate-500/15 text-slate-700 border-slate-500/40",
    shopkeeper: "bg-emerald-500/15 text-emerald-600 border-emerald-500/40",
    dealer: "bg-blue-500/15 text-blue-600 border-blue-500/40",
    distributor: "bg-lime-500/15 text-lime-600 border-lime-500/40",
  };
  return (
    <span className={`px-2 py-0.5 rounded-full border text-[11px] font-medium capitalize ${map[slab] || map.retail}`}>
      {slab === "retail" ? "B2C Retail" : slab}
    </span>
  );
};
